import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import "../TickerChart/TickerChart.css";

const TickerChart = () => {
  // Series data: 30% missing tickers, 70% missing main tickers, 50% perfect tickers, 40% ISIN tickers
  const [series] = useState([30, 70, 50, 40]); // Updated to include ISIN Tickers
  const [options] = useState({
    chart: {
      width: 380,
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "16px", // Updated font size
        fontWeight: "bold",
        colors: ["#000"], // Updated text color
      },
      dropShadow: {
        enabled: false, // Removes any shadow
      },
    },
    colors: ["#c7d7fe", "#dcdcdc", "#8197f8", "#a5bcfc"],
    legend: {
      show: false, // Hides the legend completely
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false, // Also ensures the legend is hidden on smaller screens
          },
        },
      },
    ],
    states: {
      hover: {
        filter: {
          type: 'none', // Disables any hover effect
        },
      },
      active: {
        filter: {
          type: 'none', // Disables the active state effect
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "16px", // Tooltip text font size
        color: "#999",    // Tooltip text color
      },
    },
  });
  
  return (
    <>
      <section className="section">
        <div className="full-ticker-container">
          <div className="full-ticker-header">
            <h1>
              Distribution of Ticker Statuses: Missing, Main, and ISIN Tickers
            </h1>
          </div>

          <div className="full-ticker-parent">
            <div className="full-ticker-chart-container">
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                width="100%"
                height={420}
              />
            </div>
            <div className="full-ticker-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#c7d7fe" }}
                      ></i>
                    </td>
                    <td>Missing Tickers</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#dcdcdc" }}
                      ></i>
                    </td>
                    <td>Missing Main Tickers</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#8197f8" }}
                      ></i>
                    </td>
                    <td>Perfect Tickers</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#a5bcfc" }}
                      ></i>
                    </td>
                    <td>ISIN Tickers</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TickerChart;
